export const testimonials = [
  {
    name: 'Marcus J.',
    role: 'Sneaker Collector',
    avatarSeq: 'avatar-01',
    rating: 5,
    title: 'Saved Me Hours of Searching',
    body: 'The AcBuy spreadsheet completely changed how I find products. Instead of scrolling through endless stores, I just open the spreadsheet and find exactly what I need with QC photos already attached. Absolute game changer for anyone into replica finds.'
  },
  {
    name: 'Emily R.',
    role: 'Fashion Enthusiast',
    avatarSeq: 'avatar-02',
    rating: 5,
    title: 'Best Resource for Beginners',
    body: 'I was totally lost when I first started looking for quality products. The AcBuy spreadsheet made everything so simple — clear categories, direct links, and the guides helped me understand the whole process. Could not recommend it more.'
  },
  {
    name: 'David K.',
    role: 'Regular Buyer',
    avatarSeq: 'avatar-03',
    rating: 5,
    title: 'Updated Daily, Always Reliable',
    body: 'What sets this spreadsheet apart is how frequently it gets updated. New finds every day, dead links removed quickly, and the QC tips have saved me from bad purchases multiple times. It is the only resource I trust now.'
  },
  {
    name: 'Sophia L.',
    role: 'Streetwear Fan',
    avatarSeq: 'avatar-04',
    rating: 5,
    title: 'Found My Best Pieces Here',
    body: 'Nearly every piece in my wardrobe now came through the AcBuy spreadsheet. The categorization is so well organized — shoes, hoodies, accessories — and the direct Yupoo links make ordering seamless. Truly a must-have tool.'
  },
  {
    name: 'Alex T.',
    role: 'Budget Shopper',
    avatarSeq: 'avatar-05',
    rating: 4,
    title: 'Great Value for the Price',
    body: 'I was skeptical at first, but after using the spreadsheet for a month I am genuinely impressed. The budget finds section alone is worth it. Shipping guides also helped me save a ton on international delivery.'
  },
  {
    name: 'Jessica M.',
    role: 'QC Enthusiast',
    avatarSeq: 'avatar-06',
    rating: 5,
    title: 'QC Guides Are Invaluable',
    body: 'The QC guides included with the spreadsheet are incredibly detailed. They teach you exactly what to look for before approving any order. This knowledge alone has prevented me from accepting subpar products multiple times.'
  }
];

export const trustBadges = [
  { icon: 'ri-refresh-line', label: 'Updated Daily' },
  { icon: 'ri-shield-check-line', label: 'QC Checked Products' },
  { icon: 'ri-ship-line', label: 'Multiple Shipping Options' },
  { icon: 'ri-user-smile-line', label: 'Beginner Friendly' },
  { icon: 'ri-shield-star-line', label: 'Secure Shopping' }
];

export const faqItems = [
  {
    question: 'What is the AcBuy Spreadsheet?',
    answer: 'The AcBuy Spreadsheet is a curated, regularly updated list of the best product finds across multiple categories — including shoes, hoodies, t-shirts, jackets, accessories, and more. Each entry includes direct shopping links, QC photo references, seller ratings, and pricing information, making it the most efficient way to discover and purchase quality products through AcBuy.'
  },
  {
    question: 'How often is the AcBuy Spreadsheet updated?',
    answer: 'The spreadsheet is updated daily with new product finds, and dead or outdated links are removed promptly. We continuously monitor seller quality, add new categories as trends emerge, and refresh QC reference photos to ensure you always have access to the most current and reliable shopping information available.'
  },
  {
    question: 'Is the AcBuy Spreadsheet free to use?',
    answer: 'Yes, the AcBuy Spreadsheet is completely free to access. You can browse all categories, view product links, and read our comprehensive guides without any cost. We believe in making quality shopping resources accessible to everyone in the community.'
  },
  {
    question: 'How do I use the AcBuy Spreadsheet to find products?',
    answer: 'Simply browse through the categories on our site, click on any category that interests you, and you will be taken directly to the corresponding section on our main platform. From there, you can explore individual products, view QC photos, compare sellers, and use the direct links to make your purchases through AcBuy.'
  },
  {
    question: 'What categories are available in the AcBuy Spreadsheet?',
    answer: 'We cover 14 comprehensive categories: Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes, and Other Stuff. Each category is carefully curated with the best available finds and regularly refreshed with new discoveries.'
  },
  {
    question: 'Does the AcBuy Spreadsheet include QC photos?',
    answer: 'Absolutely. Quality Control is one of the core features of our spreadsheet. Each product listing includes reference QC photos so you know exactly what to expect before placing an order. We also provide detailed QC guides that teach you how to inspect products yourself, ensuring you never accept a subpar item.'
  }
];